import { render, staticRenderFns } from "./Contenteditable.vue?vue&type=template&id=312d0cf0&scoped=true&"
import script from "./Contenteditable.vue?vue&type=script&lang=js&"
export * from "./Contenteditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d0cf0",
  null
  
)

export default component.exports